// app/frontend/components/ui/Badges/ThemedBadge.tsx
import React from 'react';
import { Badge, type BadgeProps } from '@mantine/core';

export interface ThemedBadgeProps extends BadgeProps {
  children?: React.ReactNode;
}

const ThemedBadge = React.forwardRef<HTMLDivElement, ThemedBadgeProps>(
  ({ color = '#EA580C', children, ...props }, ref) => {
    return (
      <Badge ref={ref} color={color} {...props}>
        {children}
      </Badge>
    );
  }
);

ThemedBadge.displayName = 'ThemedBadge';

export default ThemedBadge;
